import { render, staticRenderFns } from "./Historialprocedimientos.vue?vue&type=template&id=775de22a"
import script from "./Historialprocedimientos.vue?vue&type=script&lang=js"
export * from "./Historialprocedimientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports